import { createAction, props } from '@ngrx/store';

import { MediaFilesViewType } from '../reducers/live-media-files-view.reducer';

export const setView = createAction('[Media Files View] Set View', props<{ view: MediaFilesViewType }>());
